import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'daccs-form-voids-field',
  templateUrl: './form-voids-field.component.html',
  styleUrls: ['./form-voids-field.component.scss']
})
export class FormVoidsFieldComponent {

  @Input() arrForm: FormGroup;
  @Output() rowDeleted = new EventEmitter();

  public onDelete(): void {
    this.rowDeleted.emit();
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/views/daily-recon/shifts-recon/components/form-voids-recon/field/form-voids-field.component.ts